import React from 'react';
const { useState, useMemo } = React;
import { getAuthHeaders } from '../../globals.js';
import { classifyRecipient, contactNameOf } from '../../personQuotes.js';
import { isAccepted } from '../../quoteRules.js';

// «Completar datos del cliente» in the file of a quote Oike cannot classify ("Por revisar"). An explicit decision of
// the administration, with confirmation (quote-recipient.mts). As a person it stays the administration's (personal
// quotes are); as a company it is marked «Solo administración» in the same write, its document first, so bdr and cp
// never see it meanwhile. The acceptance, the document's content and payments never change.

const MESSAGES = {
  confirm_required: 'Confirmá antes de guardar.', contact_required: 'Elegí el contacto de la persona que contrata.',
  contact_fixed: 'La cotización ya tiene otro contacto: no se cambia aquí.', several_contacts: 'La cotización tiene varios contactos: revisala en Airtable.',
  not_review: 'Esta cotización ya tiene su cliente claro.', company_needs_decision: 'Completar como empresa espera una decisión sobre permisos.',
  forbidden: 'Solo la administración de la base completa estos datos.', contact_not_found: 'No se encontró ese contacto.', write_failed: 'No se pudo guardar: probá de nuevo.',
  admin_only_field_missing: 'Falta el campo «Admin Only» en Airtable (pedido a Omni). No se cambió nada.',
  company_required: 'Elegí la empresa que contrata.', company_fixed: 'La cotización ya tiene otra empresa: no se cambia aquí.', several_companies: 'La cotización tiene varias empresas: revisala en Airtable.',
  company_not_found: 'No se encontró esa empresa.', reason_required: 'Escribí el motivo (10 caracteres o más).', no_change: 'Ya estaba así.',
  document_still_restricted: 'La cotización cambió, pero su documento sigue restringido: volvé a intentar.',
};
async function call(body) {
  const res = await fetch('/api/quote-recipient', { method: 'POST', headers: getAuthHeaders(), body: JSON.stringify(body) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(MESSAGES[data.error] || `No se pudo guardar (${data.error || res.status}).`);
  return data;
}
const norm = (v) => String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export default function RecipientFix({ record, stakeholders = [], accounts = [], accountName = '', onPatched }) {
  const f = record.fields || {};
  const reasons = classifyRecipient(f).reasons;
  const current = (f['Stakeholder'] || [])[0] || '';
  const [open, setOpen] = useState(false);
  const [choice, setChoice] = useState('');
  const [contactId, setContactId] = useState(current);
  const [q, setQ] = useState('');
  const currentAccount = (f['Account'] || [])[0] || '';
  const [accountId, setAccountId] = useState(currentAccount);
  const [qa, setQa] = useState('');
  const accMatches = useMemo(() => (qa.trim() ? accounts.filter(a => norm(a.fields?.['Account Name']).includes(norm(qa))).slice(0, 6) : []), [qa, accounts]);
  const accName = (id) => accounts.find(a => a.id === id)?.fields?.['Account Name'] || accountName || 'Empresa';
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const matches = useMemo(() => (q.trim() ? stakeholders.filter(s => norm(`${contactNameOf(s)} ${s.fields?.['Email'] || ''}`).includes(norm(q))).slice(0, 6) : []), [q, stakeholders]);
  const name = (id) => contactNameOf(stakeholders.find(s => s.id === id)) || 'Contacto';
  const save = async () => {
    setBusy(true); setMsg('');
    try {
      const data = await call({ intakeId: record.id, recipient: choice, stakeholderId: choice === 'person' ? contactId : '', accountId: choice === 'company' ? accountId : '', confirm: true });
      onPatched(record.id, data.fields);
      setOpen(false);
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };
  return (
    <div className="card" style={{ borderLeft: '3px solid #9A6212', display: 'grid', gap: 8 }}>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div style={{ fontSize: 13 }}><b>Completar datos del cliente.</b> {isAccepted(f) ? 'La aceptación está registrada y no cambia; ' : ''}falta indicar con certeza quién contrata y paga{isAccepted(f) ? ': sin ese dato no se pueden armar cuotas' : ''}.</div>
        {!open && <button type="button" className="action-btn btn-primary" style={{ fontSize: 12 }} onClick={() => setOpen(true)}>Completar datos del cliente</button>}
      </div>
      <div style={{ fontSize: 12, color: 'var(--globant-muted)' }}>Por qué: {reasons.join(' · ')}.</div>
      {open && (
        <div style={{ display: 'grid', gap: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 700 }}>¿Quién contrata y paga?</div>
          <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'flex-start' }}>
            <input type="radio" name={`fix-${record.id}`} checked={choice === 'person'} onChange={() => setChoice('person')} />
            <span>Una persona, por su cuenta{accountName ? ` (${accountName} queda solo como referencia)` : ''}. Sigue siendo visible solo para la administración.</span>
          </label>
          {choice === 'person' && (
            current ? <div style={{ fontSize: 12, marginLeft: 22 }}>Contacto: <b>{name(current)}</b> (el que ya tiene la cotización)</div> : (
              <div style={{ marginLeft: 22 }}>
                {contactId ? <div style={{ fontSize: 12 }}>Contacto: <b>{name(contactId)}</b> <button type="button" className="action-btn btn-ghost" style={{ fontSize: 11 }} onClick={() => setContactId('')}>Cambiar</button></div> : <>
                  <input className="input-field" style={{ fontSize: 12, width: '100%', maxWidth: 340 }} placeholder="Buscar el contacto de la persona" aria-label="Buscar contacto" value={q} onChange={e => setQ(e.target.value)} />
                  {matches.map(s => <button key={s.id} type="button" className="action-btn btn-ghost" style={{ display: 'block', fontSize: 12, marginTop: 4 }} onClick={() => { setContactId(s.id); setQ(''); }}>{contactNameOf(s) || '(sin nombre)'}{s.fields?.['Email'] ? ` · ${s.fields.Email}` : ''}</button>)}
                </>}
              </div>
            )
          )}
          <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'flex-start' }}>
            <input type="radio" name={`fix-${record.id}`} checked={choice === 'company'} onChange={() => setChoice('company')} />
            <span>Una empresa{current ? `, con ${name(current)} como contacto` : ''}. Queda marcada «Solo administración» en la misma operación: bdr y cp no la ven.</span>
          </label>
          {choice === 'company' && (
            currentAccount ? <div style={{ fontSize: 12, marginLeft: 22 }}>Empresa: <b>{accName(currentAccount)}</b> (la que ya tiene la cotización)</div> : (
              <div style={{ marginLeft: 22 }}>
                {accountId ? <div style={{ fontSize: 12 }}>Empresa: <b>{accName(accountId)}</b> <button type="button" className="action-btn btn-ghost" style={{ fontSize: 11 }} onClick={() => setAccountId('')}>Cambiar</button></div> : <>
                  <input className="input-field" style={{ fontSize: 12, width: '100%', maxWidth: 340 }} placeholder="Buscar la empresa" aria-label="Buscar empresa" value={qa} onChange={e => setQa(e.target.value)} />
                  {accMatches.map(a => <button key={a.id} type="button" className="action-btn btn-ghost" style={{ display: 'block', fontSize: 12, marginTop: 4 }} onClick={() => { setAccountId(a.id); setQa(''); }}>{a.fields?.['Account Name']}</button>)}
                </>}
              </div>
            )
          )}
          <label style={{ fontSize: 12, display: 'flex', gap: 6 }}><input type="checkbox" checked={confirm} onChange={e => setConfirm(e.target.checked)} /> Confirmo el cliente. No cambian la aceptación, el documento, las líneas ni los pagos; queda una línea en el historial.</label>
          <div style={{ display: 'flex', gap: 6 }}>
            <button type="button" className="action-btn btn-primary" style={{ fontSize: 12 }} disabled={busy || !confirm || !(choice === 'person' ? (current || contactId) : choice === 'company' ? accountId : false)} onClick={save}>{busy ? 'Guardando…' : 'Guardar cliente'}</button>
            <button type="button" className="action-btn btn-ghost" style={{ fontSize: 12 }} disabled={busy} onClick={() => setOpen(false)}>Cancelar</button>
          </div>
        </div>
      )}
      {msg && <div role="alert" style={{ fontSize: 12, color: '#B4362C' }}>{msg}</div>}
    </div>
  );
}

/** «Solo administración»: shown in the file; changed only by this explicit action of the administration, with a reason. */
export function AdminOnlyControl({ record, onPatched }) {
  const on = record.fields?.['Admin Only'] === true;
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const save = async () => {
    setBusy(true); setMsg('');
    try { const d = await call({ intakeId: record.id, action: 'adminOnly', value: !on, reason, confirm: true }); onPatched(record.id, d.fields); setOpen(false); setReason(''); setConfirm(false); }
    catch (e) { setMsg(e.message); }
    setBusy(false);
  };
  return (
    <div style={{ fontSize: 12, display: 'grid', gap: 6 }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <span>Solo administración: <b>{on ? 'Sí' : 'No'}</b>{on ? ' (bdr y cp no la ven, ni a su documento)' : ' (aplican las reglas de siempre; una personal sigue siendo solo de la administración)'}</span>
        {!open && <button type="button" className="action-btn btn-ghost" style={{ fontSize: 11 }} onClick={() => setOpen(true)}>{on ? 'Quitar la restricción' : 'Restringir'}</button>}
      </div>
      {open && (
        <div style={{ display: 'grid', gap: 6, maxWidth: 520 }}>
          <label htmlFor={`ao-${record.id}`} style={{ color: 'var(--globant-muted)' }}>Motivo (queda en el historial)</label>
          <input id={`ao-${record.id}`} className="input-field" style={{ fontSize: 12 }} maxLength={500} value={reason} onChange={e => setReason(e.target.value)} />
          <label style={{ display: 'flex', gap: 6 }}><input type="checkbox" checked={confirm} onChange={e => setConfirm(e.target.checked)} /> {on ? 'Confirmo que bdr y cp de la empresa podrán verla según las reglas de siempre.' : 'Confirmo restringirla a la administración.'}</label>
          <div style={{ display: 'flex', gap: 6 }}>
            <button type="button" className="action-btn btn-primary" style={{ fontSize: 11 }} disabled={busy || !confirm || reason.trim().length < 10} onClick={save}>{busy ? 'Guardando…' : 'Guardar'}</button>
            <button type="button" className="action-btn btn-ghost" style={{ fontSize: 11 }} disabled={busy} onClick={() => setOpen(false)}>Cancelar</button>
          </div>
        </div>
      )}
      {msg && <div role="alert" style={{ color: '#B4362C' }}>{msg}</div>}
    </div>
  );
}
